import { bostaHttp } from 'http.js';

const userCountry = () =>
  JSON.parse(localStorage.getItem('userInfo'))?.user?.country?._id;

export const fetchCities = (payload) => {
  let url = `/cities`;
  if (userCountry()) {
    url = `/cities?countryId=${userCountry()}`;
  }
  return bostaHttp.get(url, payload);
};

export const fetchZones = (id) => {
  return bostaHttp.get(`/zones?cityId=${id}`);
};

export const getPinLocationAreas = (payload) => {
  return bostaHttp.get(`/cities/pinLocation`, payload);
};

export const getAllAreas = (payload) => {
  let url = `/cities/getAllDistricts`;
  if (userCountry()) {
    url = `/cities/getAllDistricts?countryId=${userCountry()}`;
  }
  return bostaHttp.get(url, payload);
};

export const getCountryZones = () => {
  return bostaHttp.get(`/cities/country-zones?countryId=${userCountry()}`);
};

export const getCountryTimeZone = () => {
  return bostaHttp.get(`/cities/country/time-zone/${userCountry()}`);
};